import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Paper, IconButton } from "@mui/material"; ////iconbutton er vitore button rakte hoi
import { Search } from "@mui/icons-material"; // search icon button
const MuiSearchBar = () => {
  const [videos, setVideos] = useState('');
  const navigate = useNavigate();
  const clickSubmit = (e) => {
    e.preventDefault();
    if(videos)
    {
      navigate(`search/${videos}`)
      setVideos('');
    }
  };
  return (
    <Paper
      component="form"
      elevation={0} //shadow
      onSubmit={clickSubmit}
      sx={{
        //inline style
        borderRadius: 20,
        border: "1px solid #e3e3e3",
        pl: 2,
        mr: { sm: 5 },
      }}
    >
      <input // form er input box ei kane likte hoi
        className="search-bar"
        placeholder="Search..."
        onChange={(e) => {
          setVideos(e.target.value);
        }}
        value={videos}
      />
      <IconButton type="submit" sx={{ p: "10px", color: "red" }}>
        <Search />
      </IconButton>
    </Paper>
  );
};

export default MuiSearchBar;
